import type { Action, State } from './types'

export const initialState: State = {
  pagination: {
    currentPage: 0,
    pageSize: 10
  },

  searchQuery: undefined,

  filters: {
    time: {},
    actions: [],
    types: [],
    actors: []
  }
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'pagination/currentPage/set': {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload
        }
      }
    }

    case 'pagination/pageSize/set': {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: 0,
          pageSize: action.payload
        }
      }
    }

    case 'searchQuery/set': {
      return {
        ...state,
        searchQuery: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'filters/set': {
      return {
        ...state,
        filters: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'filters/clear': {
      return {
        ...state,
        filters: initialState.filters,
        pagination: {
          ...state.pagination,
          currentPage: 0
        }
      }
    }

    case 'refreshInterval/set': {
      return {
        ...state,
        refreshInterval: action.payload
      }
    }

    case 'refreshInterval/clear': {
      return {
        ...state,
        refreshInterval: undefined
      }
    }

    default: {
      return state
    }
  }
}
